export enum EstadoCierre{
    Preabierto = 0,
    Abierto = 1,
    Cerrado = 2,
    Finalizado = 3
}